/**
 * L'identité suit le compte — la règle commune à l'accueil et à l'Abonnement.
 *
 * Une chip qui bascule fait DEVENIR le compte connecté l'enfant touché (`currentUser.object`), et
 * `formData.user` le rattrape au retour de `getSubscribePricing`. Tant qu'il parle d'un autre compte,
 * ou qu'il n'y en a pas encore, une page de l'enfant n'a rien de juste à montrer.
 */

/** Une tranche d'appel telle que le réducteur `api` la tient. */
export type ApiSlice = {
    request?: boolean
    success?: boolean
    error?: unknown
    urlParams?: Record<string, unknown>
}

type AccountId = string | number | null | undefined

/** Un échec du tarif n'est jamais masqué par un squelette : il rend la main à l'erreur et à son « Réessayer ». */
export function pricingFailed(pricing: ApiSlice | undefined): boolean {
    return pricing?.error != null && !pricing.request
}

/** `formData.user` parle-t-il du compte connecté ? */
export function sameAccount(formUserId: AccountId, currentUserId: AccountId): boolean {
    return formUserId != null && currentUserId != null && String(formUserId) === String(currentUserId)
}

/**
 * L'identité charge-t-elle encore ? — vrai tant que `formData.user` n'a pas rattrapé le compte
 * connecté. Une fois le bon compte affiché, une relecture du tarif ne rallume rien : le contenu reste.
 */
export function identityLoading(input: {
    pricing: ApiSlice | undefined
    formUserId: AccountId
    currentUserId: AccountId
}): boolean {
    const { pricing, formUserId, currentUserId } = input
    if (pricingFailed(pricing)) return false
    if (formUserId == null) return true
    if (currentUserId == null) return !!pricing?.request
    return !sameAccount(formUserId, currentUserId)
}
